import React from 'react';
import { useApp } from '../../context/AppContext';
import { avatarColor } from '../../utils/helpers';

export default function Header() {
  const { currentUser, logout, contentPieces, scheduled } = useApp();

  // Weekly schedule dots — Mon–Fri of the current week
  const today  = new Date();
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((today.getDay() + 6) % 7));

  const weekDays = Array.from({ length: 5 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return d.toISOString().slice(0, 10);
  });

  const dots = weekDays.map(dateStr => ({
    done:   (scheduled[dateStr] || []).some(id => {
      const p = contentPieces.find(c => c.id === id);
      return p?.status === 'published';
    }),
    picked: (scheduled[dateStr] || []).length > 0,
  }));

  const initials = currentUser?.avatar_initials
    || currentUser?.name?.split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2)
    || '?';

  return (
    <header className="hdr">
      <div style={{ display:'flex', alignItems:'center', gap:4 }}>
        <span style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, fontWeight:700, color:'#f0c48a', letterSpacing:'.02em' }}>
          Tayst
        </span>
        <div className="hdr-sep" />
        <span className="hdr-lbl">Content Studio</span>
      </div>

      <div className="hdr-r">
        <div>
          <div className="hdr-week-lbl">This Week</div>
          <div className="week-dots">
            {dots.map((d, i) => (
              <div key={i} className={`wd ${d.done ? 'done' : d.picked ? 'picked' : ''}`} />
            ))}
          </div>
        </div>

        <div className="nu">
          <div className="nu-av" style={{ background: avatarColor(currentUser?.name || '') }}>
            {initials}
          </div>
          <div>
            <div className="nu-nm">{currentUser?.name}</div>
            <div className="nu-rl">{currentUser?.role}</div>
          </div>
        </div>

        <button className="nu-out" onClick={logout}>Sign out</button>
      </div>
    </header>
  );
}
